import { takeLatest, put, call } from 'redux-saga/effects';
import { SagaIterator } from 'redux-saga';
import {
  IUnsubscribeGroup,
  GetUnsubscribeGroupsResponse,
} from '../../types/unsubscribeGroups/unsubscribeGroups.types';
import {
  GET_UNSUBSCRIBE_GROUPS_REQUEST,
  GET_UNSUBSCRIBE_GROUP_REQUEST,
  CREATE_UNSUBSCRIBE_GROUP_REQUEST,
  UPDATE_UNSUBSCRIBE_GROUP_REQUEST,
  DELETE_UNSUBSCRIBE_GROUP_REQUEST,
  GetUnsubscribeGroupsRequestAction,
  GetUnsubscribeGroupRequestAction,
  CreateUnsubscribeGroupRequestAction,
  UpdateUnsubscribeGroupRequestAction,
  DeleteUnsubscribeGroupRequestAction,
} from './unsubscribeGroups.types';
import {
  getUnsubscribeGroupsSuccess,
  getUnsubscribeGroupsFailure,
  getUnsubscribeGroupSuccess,
  getUnsubscribeGroupFailure,
  createUnsubscribeGroupSuccess,
  createUnsubscribeGroupFailure,
  updateUnsubscribeGroupSuccess,
  updateUnsubscribeGroupFailure,
  deleteUnsubscribeGroupSuccess,
  deleteUnsubscribeGroupFailure,
} from './unsubscribeGroups.action';
import * as unsubscribeGroupsService from '../../services/unsubscribeGroupsService/unsubscribeGroupsService';

// Worker Sagas
function* getUnsubscribeGroupsWorker(
  action: GetUnsubscribeGroupsRequestAction
): SagaIterator {
  try {
    const response: GetUnsubscribeGroupsResponse = yield call(
      unsubscribeGroupsService.getUnsubscribeGroups
    );
    yield put(getUnsubscribeGroupsSuccess(response));
  } catch (error: any) {
    const errorMessage =
      error.response?.data?.message ||
      error.message ||
      'Failed to fetch unsubscribe groups';
    yield put(getUnsubscribeGroupsFailure(errorMessage));
  }
}

function* getUnsubscribeGroupWorker(
  action: GetUnsubscribeGroupRequestAction
): SagaIterator {
  try {
    const unsubscribeGroup: IUnsubscribeGroup = yield call(
      unsubscribeGroupsService.getUnsubscribeGroupById,
      action.payload
    );
    yield put(getUnsubscribeGroupSuccess(unsubscribeGroup));
  } catch (error: any) {
    const errorMessage =
      error.response?.data?.message ||
      error.message ||
      'Failed to fetch unsubscribe group';
    yield put(getUnsubscribeGroupFailure(errorMessage));
  }
}

function* createUnsubscribeGroupWorker(
  action: CreateUnsubscribeGroupRequestAction
): SagaIterator {
  try {
    const unsubscribeGroup: IUnsubscribeGroup = yield call(
      unsubscribeGroupsService.createUnsubscribeGroup,
      action.payload
    );
    yield put(createUnsubscribeGroupSuccess(unsubscribeGroup));
  } catch (error: any) {
    const errorMessage =
      error.response?.data?.message ||
      error.message ||
      'Failed to create unsubscribe group';
    yield put(createUnsubscribeGroupFailure(errorMessage));
  }
}

function* updateUnsubscribeGroupWorker(
  action: UpdateUnsubscribeGroupRequestAction
): SagaIterator {
  try {
    const unsubscribeGroup: IUnsubscribeGroup = yield call(
      unsubscribeGroupsService.updateUnsubscribeGroup,
      action.payload
    );
    yield put(updateUnsubscribeGroupSuccess(unsubscribeGroup));
  } catch (error: any) {
    const errorMessage =
      error.response?.data?.message ||
      error.message ||
      'Failed to update unsubscribe group';
    yield put(updateUnsubscribeGroupFailure(errorMessage));
  }
}

function* deleteUnsubscribeGroupWorker(
  action: DeleteUnsubscribeGroupRequestAction
): SagaIterator {
  try {
    yield call(unsubscribeGroupsService.deleteUnsubscribeGroup, action.payload);
    yield put(deleteUnsubscribeGroupSuccess(action.payload));
  } catch (error: any) {
    const errorMessage =
      error.response?.data?.message ||
      error.message ||
      'Failed to delete unsubscribe group';
    yield put(deleteUnsubscribeGroupFailure(errorMessage));
  }
}

// Root Saga
export function* unsubscribeGroupsSaga(): SagaIterator {
  yield takeLatest(GET_UNSUBSCRIBE_GROUPS_REQUEST, getUnsubscribeGroupsWorker);
  yield takeLatest(GET_UNSUBSCRIBE_GROUP_REQUEST, getUnsubscribeGroupWorker);
  yield takeLatest(
    CREATE_UNSUBSCRIBE_GROUP_REQUEST,
    createUnsubscribeGroupWorker
  );
  yield takeLatest(
    UPDATE_UNSUBSCRIBE_GROUP_REQUEST,
    updateUnsubscribeGroupWorker
  );
  yield takeLatest(
    DELETE_UNSUBSCRIBE_GROUP_REQUEST,
    deleteUnsubscribeGroupWorker
  );
}
